// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import { Card } from "react-bootstrap";

import "./Style.css";
// import axios from 'axios';

export default function ViewProduct({
  showView,
  closeModal,
  refreshPage,
  products,
}) {
  const handleClose = () => {
    closeModal();
  };

  const productCards = products ? (
    <Card key={products.id} className="mb-3">
      <Card.Body>
        {/* <Card.Title>{products.product_name}</Card.Title> */}
        <Card.Text>
          <strong>product Name:</strong> {products?.product_name}
          <br />
          <strong>Catgeory:</strong> {products?.category.name}
          <br />
          <strong>Sub-Category:</strong> {products.sub_category?.name}
          <br />
          <strong>Simple Code:</strong> {products.simple_code?.simple_code}
          <br />
          <strong>Price:</strong> {products?.price}
          <br />
          <strong>Unit of Measure:</strong> {products.unit_of_measure?.name}
          <br />
          <strong>Group:</strong> {products.group?.name}
          <br />
          <strong>Description 1:</strong> {products?.description1}
          <br />
          <strong>Description 2:</strong> {products?.description2}
          <br />
          <strong>Status:</strong> {products?.status}
        </Card.Text>
      </Card.Body>
    </Card>
  ) : (
    <p>No product available.</p>
  );

  return (
    <div className="ViewTransaction">
      <Modal show={showView} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>View Product Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>
          {productCards}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#c4281b", border: "none" }}
            onClick={refreshPage}
          >
            Refresh
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
